





import { Component, Prop, Vue } from 'vue-property-decorator';
import { HeadingLevelType } from './types';

@Component
export default class AppHeading extends Vue {
  @Prop({ type: String, default: '1' })
  readonly level!: HeadingLevelType;

  @Prop({ type: String, default: '' })
  readonly mod!: string;

  get headingLevel(): string {
    return `h${this.level}`;
  }

  get modClasses(): Array<string> {
    const { mod } = this;
    if (!mod.length) return [];
    return mod.split(', ').map((item) => `heading_${item}`);
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/uikit/typography/Heading/AppHeading.vue